<div class="header">
  <h2>Assignment to Duties</h2>
  <button mat-raised-button (click)="add()">
    <mat-icon>add</mat-icon> <span>Add Assignment to Duty</span>
  </button>
  <button mat-raised-button (click)="refresh()">
    <mat-icon>refresh</mat-icon>
  </button>
</div>
<div>
  <ng-template
    [flLoading]="loadingKey"
    [flLoadingUntil]="assignmentToDuties$ | async"
    flLoadingStrategy="overlay"
    flLoadingColor="primary"
  >
    <table mat-table [dataSource]="assignmentToDuties$" fxFlex="100">
      <ng-container matColumnDef="startDate">
        <th mat-header-cell *matHeaderCellDef>Start Date</th>
        <td mat-cell *matCellDef="let assignmentToDuty">
          {{ assignmentToDuty.startDate | date : 'MM/dd/yyyy  HH:mm' }}
        </td>
      </ng-container>
      <ng-container matColumnDef="endDate">
        <th mat-header-cell *matHeaderCellDef>End Date</th>
        <td mat-cell *matCellDef="let assignmentToDuty">
          {{ assignmentToDuty.endDate | date : 'MM/dd/yyyy  HH:mm' }}
        </td>
      </ng-container>
      <ng-container matColumnDef="aircraftMakeModelId">
        <th mat-header-cell *matHeaderCellDef>Aircraft Make Model</th>
        <td mat-cell *matCellDef="let assignmentToDuty">
          <ng-container *ngIf="assignmentToDuty.aircraftMakeModel$ | async as aircraftMakeModel">
            {{ aircraftMakeModel.code }}
          </ng-container>
        </td>
      </ng-container>
      <ng-container matColumnDef="dutyPosition">
        <th mat-header-cell *matHeaderCellDef>Duty Position</th>
        <td mat-cell *matCellDef="let assignmentToDuty">
          {{ assignmentToDuty.dutyPositionType }}
        </td>
      </ng-container>
      <ng-container matColumnDef="processingState">
        <th mat-header-cell *matHeaderCellDef>Processing State</th>
        <td mat-cell *matCellDef="let assignmentToDuty">
          {{ assignmentToDuty.processingState | humanize }}
        </td>
      </ng-container>
      <ng-container matColumnDef="lastProcessedDate">
        <th mat-header-cell *matHeaderCellDef>Last Processed Date</th>
        <td mat-cell *matCellDef="let assignmentToDuty">
          {{ (assignmentToDuty.lastProcessedDate | date : 'MM/dd/yyyy HH:mm') || '--' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="processingError">
        <th mat-header-cell *matHeaderCellDef>Processing Error</th>
        <td mat-cell *matCellDef="let assignmentToDuty" class="prd-processing-error-text">
          {{ assignmentToDuty.processingError }}
        </td>
      </ng-container>
      <ng-container matColumnDef="prdSourceSystemId">
        <th mat-header-cell *matHeaderCellDef>PRD Source System Id</th>
        <td mat-cell *matCellDef="let assignmentToDuty">
          {{ assignmentToDuty.prdSourceSystemId }}
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let assignmentToDuty">
          <button mat-icon-button [matMenuTriggerFor]="assignmentToDutyActions">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #assignmentToDutyActions="matMenu">
            <a mat-menu-item (click)="edit(assignmentToDuty)"> <mat-icon>edit</mat-icon>Edit </a>
            <a mat-menu-item (click)="delete(assignmentToDuty.id)">
              <mat-icon>delete</mat-icon>Delete
            </a>
          </mat-menu>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </ng-template>
</div>
